import { useAtom } from 'jotai';
import { screenshotDiffAtom } from '~/atoms/atoms';
import ScreenshotComparisonViewer from '~/components/common/ScreenshotComparisonViewer';

export default function ScreenshotDiffViewer() {
  const [screenshotDiff, setScreenshotDiff] = useAtom(screenshotDiffAtom);

  return (
    <ScreenshotComparisonViewer
      isOpen={!!screenshotDiff.opened}
      leftOperationId={screenshotDiff.oldOperationId}
      rightOperationId={screenshotDiff.newOperationId}
      rightDirectScreenshots={screenshotDiff.rightDirectScreenshots}
      onClose={() => setScreenshotDiff({ ...screenshotDiff, opened: false })}
    />
  );
}
